// 参数API
import request from '@/utils/request'

/**
 * 根据项目pid查询指定的安装工单
 * @param pid
 * @returns {*}
 */
export function getParam(pid) {
    return request({
        url: '/assign/'+pid+'/param',
        method: 'get'
    })
}

/**
 * 发送远程指令
 * @param data
 * @returns {*}
 */
export function sendZL(params) {
    return request({
        url: '/project/control/sendZL',
        method: 'post',
        params
    })
}
